module.exports = __webpack_public_path__ + "016a1f7413429b30f3df29517d6e1237.png";